import { render, staticRenderFns } from "./CapacityTableSection.vue?vue&type=template&id=5c2ca92d&"
import script from "./CapacityTableSection.vue?vue&type=script&lang=js&"
export * from "./CapacityTableSection.vue?vue&type=script&lang=js&"
import style0 from "./CapacityTableSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports